import React from 'react';

import SvgIcon from './SvgIcon';

const RemoveCircle = props => (
    <SvgIcon width="15" height="15" {...props}>
        <circle fill="transparent" cx="7.5" cy="7.5" r="6.5" />
        <path d="M3.5 7.5L11.5 7.5" />
    </SvgIcon>
);

RemoveCircle.displayName = 'RemoveCircleIcon';

export default RemoveCircle;
